jQuery(document).ready(function ($) {
    var $dates = $('.bloc_chronologie .date');
    if (!$dates.length) return;

    var COUNT_OFFSET = 15;
    var COUNT_DURATION = 1500;

    $dates.each(function () {
        var $year = $(this).find('.yyyy');
        var target = parseInt($year.text(), 10);
        $(this).data('targetYear', isNaN(target) ? null : target);
        if (!isNaN(target)) {
            $year.text(target - COUNT_OFFSET);
        }
    });

    function isInView($el) {
        var rect = $el[0].getBoundingClientRect();
        var triggerLine = window.innerHeight * 0.85;
        return rect.top < triggerLine && rect.bottom > 0;
    }

    function animateYear($date) {
        var target = $date.data('targetYear');
        var $year = $date.find('.yyyy');

        if (target === null || target === undefined) return;

        $date.addClass('is-counting');

        $({val: target - COUNT_OFFSET}).animate({val: target}, {
            duration: COUNT_DURATION,
            easing: 'swing',
            step: function () {
                $year.text(Math.floor(this.val));
            },
            complete: function () {
                $year.text(target);
                $date.removeClass('is-counting');
            }
        });
    }

    function checkDates() {
        $dates.not('.is-visible').each(function () {
            var $date = $(this);
            if (isInView($date)) {
                $date.addClass('is-visible');
                animateYear($date);
            }
        });
    }

    var ticking = false;
    $(window).on('scroll resize', function () {
        if (!ticking) {
            window.requestAnimationFrame(function () {
                checkDates();
                ticking = false;
            });
            ticking = true;
        }
    });

    checkDates();
});
